import Model from '@/models/Model.js';

export default class FeatureFlag extends Model {
    static entity = 'feature_flags';

    static modelName = 'FeatureFlag';

    static searchable() {
        return ['label', 'description', 'name'];
    }

    static fields() {
        return {
            id: this.attr(null),
            name: this.string(''),
            label: this.string(''),
            description: this.string(''),
            global_only: this.boolean(false),
            globally_enabled: this.boolean(false),
            enabled_users_count: this.attr(0),
            total_users_count: this.attr(0),

            ...super.fields(),
        };
    }
}
